// Loop gift widget: load app styles and initialize inside Quick View
(function () {
  var SELECTOR = '[id^="loop-gw-container-id-"]';

  function loadLoopAssets(handle) {
    if (document.querySelector('[data-loop-gw-asset]')) return Promise.resolve();
    return fetch('/products/' + handle)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('link[rel="stylesheet"][href*="loop"], style').forEach(function (el) {
          if (el.tagName === 'STYLE' && el.textContent.indexOf('loop-gw') === -1) return;
          var clone = el.cloneNode(true);
          clone.setAttribute('data-loop-gw-asset', '');
          document.head.appendChild(clone);
        });
      });
  }

  function runScripts(block, productId) {
    // Skip if the theme's injection already ran them (jQuery .html() does)
    if (window.LOOP_GIFT_WIDGET && window.LOOP_GIFT_WIDGET[productId]) return;
    block.querySelectorAll('script').forEach(function (old) {
      if (old.src && window.LoopSubscriptionsGift) return; // library already loaded
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) { s.setAttribute(a.name, a.value); });
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
  }

  function initWidget(container) {
    if (container.dataset.loopGwInit) return;
    container.dataset.loopGwInit = '1';

    var productId = container.id.replace('loop-gw-container-id-', '');
    var block = container.closest('.shopify-app-block') || container.parentElement;
    var inline = Array.prototype.find.call(block.querySelectorAll('script'), function (s) {
      return s.textContent.indexOf('LOOP_GIFT_WIDGET') !== -1;
    });
    var match = inline && inline.textContent.match(/"handle":"([^"]+)"/);
    if (!match) return;

    loadLoopAssets(match[1]).then(function () {
      runScripts(block, productId);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Widgets present at page load (the PDP) already work, so mark them done
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.dataset.loopGwInit = '1';
    });

    new MutationObserver(function () {
      document.querySelectorAll(SELECTOR).forEach(initWidget);
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
